import "core-js/modules/es6.symbol";
import React from 'react';
import ReactDOM from 'react-dom';
import * as ReactRouter from 'react-router-dom';
import ReactTransitionGroup from 'react-addons-css-transition-group';
import * as Redux from 'redux';
import {connect, Provider} from 'react-redux';
import createReactClass from 'create-react-class';

import * as ReactRouterRedux from 'react-router-redux';
import Immutable from 'immutable';
import TalentCore from '../index';
import PropTypes from 'prop-types';
import ReactTransformTenchmark from '../react-transform-tenchmark';


React.PropTypes = PropTypes;
React.createClass = createReactClass;
window.React = React;
window.ReactDOM = ReactDOM;
window.ReactRouter = ReactRouter;
window.ReactTransitionGroup = ReactTransitionGroup;
window.Redux = Redux;
window.ReactRedux = {connect, Provider};
window.ReactRouterRedux = ReactRouterRedux;
window.Immutable = Immutable;
window.TalentCore = TalentCore;
window.PropTypes = PropTypes;
window.ReactTransformTenchmark = ReactTransformTenchmark;